import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import './styles/index.css';
import './styles/theme1.css';
import './styles/theme2.css';
import './styles/theme3.css';

createRoot(document.getElementById('root')).render(React.createElement(App));